import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { compressToBase64 } from 'lz-string';

import { AppSyncClientCreate } from '../../../backends/AppSyncClientCreate';
import GetMyEndpoint from '../../../q/create/GetMyEndpoint'; // TODO(clairbee): add to 'refetch queries' on update endpoint?
import UpdateEndpoint from '../../../q/create/UpdateEndpoint';
import DeleteEndpoint from '../../../q/create/DeleteEndpoint';
import GetMyApp from '../../../q/create/GetMyApp';
import GetMyApps from '../../../q/create/GetMyApps';
import AddEndpointImage from '../../../q/create/AddEndpointImage';
import AddEndpointTrack from '../../../q/create/AddEndpointTrack';
import App from '../../../modules/data/App';
import Endpoint from '../../../modules/data/Endpoint';
import PublisherEndpointForm from '../../../components/forms/app/Endpoint';
import AORTypes from '../../../types';

class PublisherEndpointEdit extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherEndpointEdit';

    this.onCancel = this.onCancel.bind(this);
    this.onDel = this.onDel.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onCancel() {
    const { history, match: { params: { appUuid } } } = this.props;
    history.push(`/editapp/${appUuid}`);
  }

  async onDel() {
    const {
      history, onDel, app, endpoint, getDirectionsService,
      getAnalyticsService,
    } = this.props;

    app.postProcess();
    app.pp.endpoints = app.pp.endpoints.filter((w) => w.uuid !== endpoint.data.uuid);
    app.pp.endpointIds = app.pp.endpointIds.filter((w) => w !== endpoint.data.uuid);

    let bounds;
    let route;
    let legs;
    let routeduration;
    let routelen;
    if (app.pp.endpoints.length > 1 && app.pp.travelType !== 3) {
      const routeInfo = await getDirectionsService().getDirections(app);
      bounds = JSON.stringify(routeInfo.bounds);
      route = compressToBase64(JSON.stringify(routeInfo.route));
      legs = compressToBase64(JSON.stringify(routeInfo.legs));
      routeduration = routeInfo.routeduration;
      routelen = routeInfo.routelen;
    } else if (app.pp.endpoints.length === 1) {
      bounds = JSON.stringify({
        latAvg: app.pp.endpoints[0].lat,
        lonAvg: app.pp.endpoints[0].lon,
        latDelta: App.DEFAULT_LAT_DELTA,
        lonDelta: App.DEFAULT_LON_DELTA,
      });
      route = compressToBase64('[]');
      legs = compressToBase64('[]');
      routeduration = 0;
      routelen = 0;
    } else {
      bounds = JSON.stringify({
        latAvg: 0,
        lonAvg: 0,
        latDelta: App.DEFAULT_LAT_DELTA,
        lonDelta: App.DEFAULT_LON_DELTA,
      });
      route = compressToBase64('[]');
      legs = compressToBase64('[]');
      routeduration = 0;
      routelen = 0;
    }

    return onDel(endpoint.data.uuid, bounds, route, legs, routeduration, routelen)
      .then((result) => {
        getAnalyticsService().report.event('endpointDelSuccess', 'create');
        history.push(`/editapp/${endpoint.data.app}/3`);
        return result;
      });
  }

  async onSave(values) {
    const {
      onSave,
      endpoint,
      getAnalyticsService,
    } = this.props;

    const updateParams = {
      uuid: endpoint.data.uuid, // should not cause any trouble for createEndpoint
      app: endpoint.data.app,
      name: values.name,
      extraStay: values.extraStay,
      size: values.size,
      lat: values.lat, // conditional?
      lon: values.lon, // conditional?
      coords: Endpoint.latLngToCoords(values.lat, values.lon), // conditional?
      bounds: values.bounds,
      route: values.route,
      legs: values.legs,
      routeduration: values.routeduration,
      routelen: values.routelen,
    };

    console.log('updateParams');
    console.log(updateParams);
    return onSave(updateParams)
      .then((result) => {
        getAnalyticsService().report.event('endpointSaveSuccess', 'create');

        // TODO(clairbee): remove the below or merge the logic with PublisherEndpointAdd.js
        if (result.data.createEndpoint !== undefined) {
          const { uuid } = result.data.createEndpoint;
          if (uuid !== undefined) {
            endpoint.data.uuid = uuid;
          }
        }
        return result;
      });
  }

  // onRefresh() {
  //   console.log('onRefresh() is called');
  //   const { data } = this.props;
  //   return data.refresh();
  // }

  render() {
    const {
      history, direction, app, endpoint, position,
      onAddImage,
      onAddTrack,
      onRefresh,
      getUploader,
      user,
      getDirectionsService,
      getAnalyticsService,
    } = this.props;

    if (!user || !app || !endpoint) {
      return (
        <>
        </>
      );
    }

    return (
      <PublisherEndpointForm
        position={position}
        app={app}
        endpoint={endpoint}
        onCancel={this.onCancel}
        onNext={this.onCancel}
        onDel={this.onDel}
        onSave={this.onSave}
        onAddImage={onAddImage}
        onAddTrack={onAddTrack}
        onRefresh={onRefresh}
        getUploader={getUploader}
        user={user}
        getDirectionsService={getDirectionsService}
        getAnalyticsService={getAnalyticsService}
        history={history}
        direction={direction}
      />
    );
  }
}

PublisherEndpointEdit.defaultProps = {
  app: new App(),
  endpoint: new Endpoint(),
  position: null, // it's unset until it's autodetected
  user: null,
};

PublisherEndpointEdit.propTypes = {
  app: PropTypes.instanceOf(App),
  endpoint: PropTypes.instanceOf(Endpoint),
  onSave: PropTypes.func.isRequired,
  onDel: PropTypes.func.isRequired,
  onAddImage: PropTypes.func.isRequired,
  onAddTrack: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  position: AORTypes.Position,
  user: AORTypes.AWS.Cognito.User,
  getDirectionsService: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
};

export default compose(
  graphql(GetMyApp, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      // console.log('graphql props');
      // console.log(props);
      if (!props.data.getMyApps) {
        return {};
      }
      const app = App.createFromData(props.data.getMyApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        onRefresh: props.data.refetch,
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.appUuid,
      },
      client: AppSyncClientCreate(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientCreate,
  }),
  graphql(GetMyEndpoint, {
    // props: props => ({
    //   endpoint: Endpoint.createFromData(props.data.getMyEndpoint),
    // }),
    props: (props) => ({
      // console.log('graphql query');
      // console.log(props);
      // console.log(props.data);
      // return {
      onRefresh: props.data.refetch,
      endpoint: Endpoint.createFromData(props.data.getMyEndpoint),
      // };
    }),
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientCreate(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientCreate,
  }),
  graphql(UpdateEndpoint, {
    props: (props) => ({
      onSave: (updateParams) => props.mutate({
        variables: updateParams,
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }],
      /* fetchPolicy: 'cache-and-network' */
      client: AppSyncClientCreate(props.user),
    }),
  }),
  graphql(AddEndpointImage, {
    // name: 'AddEndpointImage',
    props: (props) => ({
      onAddImage: ({
        uuid, name, isVertical, lat, lon, type,
      }) => props.mutate({
        variables: {
          uuid,
          name,
          isVertical,
          lat,
          lon,
          type,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyEndpoint,
        props: (p) => ({
          endpoint: Endpoint.createFromData(p.data.getMyEndpoint),
        }),
        variables: { uuid: props.uuid },
        // variables: { uuid: props.endpoint.data.uuid },
        client: AppSyncClientCreate(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientCreate(props.user),
    }),
  }),
  graphql(DeleteEndpoint, {
    props: (props) => ({
      onDel: (uuid, bounds, route, legs, routeduration, routelen) => props.mutate({
        variables: {
          uuid, bounds, route, legs, routeduration, routelen,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }],
      client: AppSyncClientCreate(props.user),
    }),
  }),
  graphql(AddEndpointTrack, {
    // name: 'AddEndpointTrack',
    props: (props) => ({
      onAddTrack: ({
        uuid, name, type,
      }) => props.mutate({
        variables: {
          uuid,
          name,
          type,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyEndpoint,
        props: (p) => ({
          endpoint: Endpoint.createFromData(p.data.getMyEndpoint),
        }),
        variables: { uuid: props.uuid },
        // variables: { uuid: props.endpoint.data.uuid },
        client: AppSyncClientCreate(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientCreate(props.user),
    }),
  })
)(PublisherEndpointEdit);
